import React, { useEffect, useState } from "react";
import "./Feeding.css";
import { formula_accordian_img } from "assets/icons";
import Accordion from "react-bootstrap/Accordion";
import useFullPageLoader from "common/UseFullPageLoader";
import { breastFeedingListApi } from "services/breastFeeding";
import moment from "moment";
import { dateFormatWithTime } from "utils/dateFormat";
import { formatTimeInDays } from "utils/common";

const Feeding = ({ _child }) => {
  const [loader, onShow, onHide] = useFullPageLoader();
  const [feedingList, setFeedingList] = useState([]);
  const [meta, setMeta] = useState({});
  const [selected, setSelected] = useState({});


  const fetchData = async () => {
    try {
      onShow();
      const { data, status } = await breastFeedingListApi({ childId: _child, limit: 5000 });
      if (status === 200) {
        setFeedingList(data?.data);
        setMeta(data?.meta);
      }
    } catch (e) {
      console.log(e);
    } finally {
      onHide();
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {loader}
      <div className="feeding_parent">
        <div className="feeding_wraper">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-12">
              <div className="formula_lft_side">
                <div className="formula_accordian">
                  <Accordion className="w-75">
                    <p className="formula_logo">Formula Logs</p>


                    {
                      feedingList?.map((feeding, i) => {
                        return <Accordion.Item eventKey={i} key={i}>
                          <Accordion.Header>
                            <div className="formula_header">
                              <h6>{moment(feeding._id, "YYYY-MM-DD").format("LL")}</h6>
                            </div>
                          </Accordion.Header>

                          {
                            feeding?.documents?.map((ele, j) => {
                              return <Accordion.Body key={j} onClick={() => setSelected(ele)}>
                                <div className="formula_timimg_inside">
                                  <div className="formula_timing_wraper">
                                    <div className="formula_lft_img">
                                      <img src={formula_accordian_img} />
                                    </div>

                                    <div className="formula_rgt_content">
                                      <div className="formula_rgt_top">
                                        <div className="formula_timimg">
                                          <span>{dateFormatWithTime(ele?.createdAt)}</span>
                                          <div className="formula_liter">
                                            <b>L: {formatTimeInDays(ele?.leftSideTime)}</b>
                                            <b className="bold_right">R: {formatTimeInDays(ele?.rightSideTime)}</b>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </Accordion.Body>
                            })
                          }
                        </Accordion.Item>
                      })
                    }
                  </Accordion>
                </div>
              </div>
            </div>

            {
              selected?._id
                ?
                < div className="col-lg-6 col-md-6 col-sm-12">
                  <div className="formula_right_side ">
                    <div className="doctor_visit_rgt">
                      <div className="doctor_visit_card">

                        <b>Breast Feeding</b>
                        <div className="date-time">
                          {`L: ${formatTimeInDays(selected?.leftSideTime)} R: ${formatTimeInDays(selected?.rightSideTime)}`}
                          <br />
                        </div>

                        <b>Date & Time</b>
                        <div className="date-time">
                          {dateFormatWithTime(selected?.createdAt)}
                          <br />
                        </div>

                        <b> Duration</b>
                        <div className="date-time">
                          {`${formatTimeInDays(selected?.leftSideTime + selected?.rightSideTime)}`}
                          <br />
                        </div>

                        {selected?.note
                          &&
                          <>
                            <b>Note</b>
                            <div className="motorskilltracking-note feeding_note">
                              <p>
                                {selected?.note}
                              </p>
                            </div>
                          </>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                :
                null
            }

          </div>
        </div>
      </div >
    </>
  );
};

export default Feeding;
